import React from 'react';

import { faClock } from '@fortawesome/free-solid-svg-icons/faClock';
import { useIntl } from 'react-intl';
import { Box } from '@osmosis/react-ui/components/Box';
import { H3 } from '@osmosis/react-ui/components/Text';
import { Icon } from '@osmosis/react-ui/components/Icon';

type QuizSummaryHeaderProps = {
  estimatedTime: number;
  titleId?: string;
};

/**
 * Formates the time in x-h:y-mins format.
 * @param minutes
 */
export function formatMinutesToHrsMins(minutes: number): string {
  const hrs = Math.floor(minutes / 60);
  const mins = minutes % 60;
  let result = '';
  if (hrs > 0) result += `${hrs}hr${hrs > 1 ? 's' : ''} `;
  result += `${mins} min${mins !== 1 ? 's' : ''}`;
  return result.trim();
}

/**
 * Renders the QuizSummaryModalHeader.
 */
const QuizSummaryModalHeader: React.FC<QuizSummaryHeaderProps> = ({
  estimatedTime,
  titleId,
}) => {
  const formattedTime = formatMinutesToHrsMins(estimatedTime);
  const intl = useIntl();
  return (
    <Box sx={{ padding: 3, borderBottom: '1px solid #E5E7EB' }}>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <H3
          id={titleId}
          color={'#404040'}
          data-testid="quiz-summary-header-title"
        >
          {intl.formatMessage({
            id: 'quiz_start_modal.quiz_summary',
            defaultMessage: 'Quiz Summary',
          })}
        </H3>
        <Box
          display="flex"
          alignItems="center"
          fontWeight="500"
          data-testid="quiz-summary-estimated-time"
        >
          <Icon
            icon={faClock}
            size="sm"
            style={{ margin: '8px', height: '20px', width: '20px' }}
            color="#004D99"
            data-testid="quiz-summary-clock-icon"
          />
          {intl.formatMessage({
            id: 'quiz_start_modal.estimated_time',
            defaultMessage: 'Est. time:',
          })}
          <span
            style={{ marginLeft: 4 }}
            data-testid="quiz-summary-estimated-time-value"
          >
            {formattedTime}
          </span>
        </Box>
      </Box>
    </Box>
  );
};

export default QuizSummaryModalHeader;
